import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeStockEntryCreate,
  detail: routeStockEntryDetail,
  home: routeStockEntriesHome,
  root: routeStockEntriesRoot,
} = createDoctypeRoutes({
  createName: 'new-stock-entry',
  createPath: 'new-stock-entry',
  detailName: 'stock-entry-detail',
  doctype: DOCTYPES.STOCK_ENTRY,
  homeName: 'stock-entries-home',
  ifOwner: false,
  path: 'stock-entries',
  views: {
    create: async () => await import('@/components/viewsExternal/stockEntry/AddStockEntry.vue'),
    detail: async () => await import('@/components/viewsExternal/stockEntry/ViewStockEntry.vue'),
    list: async () => await import('@/components/viewsExternal/stockEntry/StockEntryView.vue'),
  },
})

export {
  routeStockEntriesHome,
  routeStockEntriesRoot,
  routeStockEntryCreate,
  routeStockEntryDetail,
}
